module.exports = __webpack_public_path__ + "img/sale-lbl.2db3dd8e.png";